export const signatureSundayMondayTemplate = [
  {
    technician:"Rachel" ,
    sortOrder:2,
    slots:[],
    unavailability:[
      {start:0,end:47}
    ]
  },
  {
    technician:"Rina" ,
    sortOrder:1,
    slots:[],
    unavailability:[
      {start:0,end:47}
    ]
  },
  {
    technician:"Karen",
    sortOrder:3,
    slots:[],
    unavailability:[
      {start:0,end:47}
    ]
  }
];
